import { AxiosRequestConfig } from 'axios'
import {
  NotificationBanner as Data,
  NotificationBannerCollection as Collection,
} from '@/typings/api/NotificationBanner'
import {
  BaseApiResponse as BR,
} from '@/typings/common'
import get from 'lodash/get'
import { BaseApiAuth } from '@/api/BaseApiAuth'


export class NotificationsBannersApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'notifications/banners';

  public show(
    params: Record<string, unknown> = {},
    config: AxiosRequestConfig = {},
  ) {
    const path = 'show/'
    const [url] = this.getUrl(path, params)
    return this.request<never, BR<Data>>('GET', url, { params, ...config })
      .catch((e) => {
        const data = get(e, 'response.data') as BR<Data>

        if (data?.data === null) {
          return data
        }

        return Promise.reject(e)
      })
  }

  public close(
    id: Data['id'],
    params: Record<string, unknown> = {},
    config: AxiosRequestConfig = {},
  ) {
    const path = `${id}/close/`
    const [url] = this.getUrl(path, params)
    return this.request<never, BR<Data>>('POST', url, { params, ...config })
  }
}
